import { Flex,Text,useColorMode } from "@chakra-ui/react"
export default function PocNotFound({message}){
const {colorMode}=useColorMode();
    return (
<>
<Flex direction={"column"} h="full" minH={"200px"} w="full" justifyContent={'center'} alignItems={"center"} >

<Text textAlign={"center"} fontSize={"20"} color={colorMode === "light" ? "#232323" : "white"}>
{message}
</Text>
    
</Flex>
</>
    )
}